import { AiProcessExecutionStatus } from 'constants/aiProcessRuns';

// Maps a run status to the theme palette key whose `.main` paints the meter
// fill, so the bar tracks the same colour language as StatusPill / StatusIcon
// instead of hardcoding hex. Anything unmapped (pending, cancelled, skipped)
// falls back to the neutral track in the styles file.
export const STATUS_TO_FILL_PALETTE = {
  [AiProcessExecutionStatus.RUNNING]: 'info',
  [AiProcessExecutionStatus.AWAITING_CONFIRMATION]: 'warning',
  [AiProcessExecutionStatus.COMPLETED]: 'success',
  [AiProcessExecutionStatus.FAILED]: 'error',
};
